import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChevronUp = function ChevronUp(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74023 15.0371L10.7861 6.78711C11.1514 6.42188 11.5381 6.25 11.9893 6.25C12.4512 6.25 12.8486 6.43262 13.2031 6.79785L21.249 15.0371C21.5283 15.3164 21.6787 15.6602 21.6787 16.0791C21.6787 16.9062 21.0127 17.583 20.1855 17.583C19.7773 17.583 19.3799 17.4219 19.0898 17.1104L12 9.80566L4.89941 17.1104C4.59863 17.4111 4.22266 17.583 3.80371 17.583C2.97656 17.583 2.31055 16.9062 2.31055 16.0791C2.31055 15.6709 2.46094 15.3164 2.74023 15.0371Z"
  })));
};

ChevronUp.displayName = 'ChevronUp';
export default ChevronUp;